// extracted by mini-css-extract-plugin
export var exploreMapSwitch = "styles-module__exploreMapSwitch___Vp4Yk";
export var mapView = "styles-module__mapView___NdHDt";
export var listView = "styles-module__listView___RygLh";